var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlansIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.97 24.451A13.451 13.451 0 1124.521 11 13.451 13.451 0 0137.97 24.451z",
    fill: "#fda529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.522 28.15l-.271 1.614a.527.527 0 01-.515.4H19.167a.527.527 0 01-.515-.4l-.271-1.614zm-6.09-9.415a.526.526 0 01.436.2l3.4 4.308 2.762-1.816a.536.536 0 01.594 0 .52.52 0 01.215.546l-1.071 4.826H18.137l-1.07-4.826a.519.519 0 01.2-.536.535.535 0 01.578-.034l3.27 1.843 2.9-4.286a.531.531 0 01.421-.233z",
    fill: "#fff"
  })));
}

export default SvgPlansIcon;